import { DraftConfigurationText } from '@/types';
import { adjustTextStyleOffset } from '@/components/draft/draftState/actions/helper/adjustTextStyleOffset';

export function updateTextCoordinates(text: DraftConfigurationText) {
  adjustTextStyleOffset(text.style, text.content);
}
